<template>
  <div class="absolute inset-0 w-full h-full">
    <Grainient
      color1="#4A2ACC"
      color2="#000000"
      color3="#B09FEF"
      :time-speed="0.4"
      :color-balance="0.0"
      :warp-strength="0.65"
      :warp-frequency="5.0"
      :warp-speed="2.0"
      :warp-amplitude="50.0"
      :blend-angle="0.0"
      :blend-softness="0.05"
      :rotation-amount="500.0"
      :noise-scale="2.0"
      :grain-amount="0"
      :grain-scale="2.0"
      :grain-animated="false"
      :contrast="1.5"
      :gamma="1.0"
      :saturation="1.0"
      :center-x="0.0"
      :center-y="0.0"
      :zoom="0.9"
    />
  </div>
</template>

<script setup lang="ts">
  import Grainient from './Grainient.vue'
</script>
